import { Label } from '../atoms/label.component';
import { NonFloatingLabelStyles } from './non-floating-label.styles';
import { NonFloatingLabelProps } from './types';

export const NonFloatingLabel = ({ children, disabled, hasError, ...rest }: NonFloatingLabelProps) => {
  const styles = NonFloatingLabelStyles.nonFloatingLabel({ disabled, hasError });
  return (
    <Label css={styles} {...rest}>
      <>{children}</>
    </Label>
  );
};
